module.exports = __webpack_public_path__ + "static/img/logo.2983b0e0.jpg";